import { render, staticRenderFns } from "./option.vue?vue&type=template&id=9ad5bcc8&scoped=true"
import script from "./option.vue?vue&type=script&lang=js"
export * from "./option.vue?vue&type=script&lang=js"
import style0 from "./option.vue?vue&type=style&index=0&id=9ad5bcc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad5bcc8",
  null
  
)

export default component.exports